import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Notepad, UpdateNotepadDto } from 'types';

export const updateNotepad = ({
    data,
    notepadId,
}: {
    data: UpdateNotepadDto;
    notepadId: number;
}): Promise<Notepad> => {
    return axios.put(`/api/notepad/${notepadId}`, data);
};

type UseUpdateNotepadOptions = {
    config?: MutationConfig<typeof updateNotepad>;
};

export const useUpdateNotepad = ({ config }: UseUpdateNotepadOptions ) => {
    return useMutation({
        onError: (_, __, context: any) => {
            if (context?.previousNotepad) {
                queryClient.setQueryData(['notepad'], context.previousNotepad);
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['notepad']);
            queryClient.invalidateQueries(['systemOverview']);
        },
        ...config,
        mutationFn: updateNotepad,
    });
};